<template>
  <div class="col-12 col-md-12 col-lg-7 text-center">
    <div class="tit">
      <p>A(O) <strong>{{razaoSocial}}</strong> possui inscrição estadual?</p>
    </div>
    <div class="text-center fixedOptions">
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithCorporateGroup">Sim</button>
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithoutCorporateGroup">Não</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    submitWithCorporateGroup() {
      this.$emit('on-submit', {Empresa: {TemInscricaoEstadual: true}})
    },
    submitWithoutCorporateGroup() {
      this.$emit('on-submit', {Empresa: {TemInscricaoEstadual: false}})
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/InscricaoEstadualStep.vue